/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_TitleInputs */

const es_privacy_policy_retention_title = /** @type {(inputs: Privacy_Policy_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Retencion de Datos`)
};

const en_privacy_policy_retention_title = /** @type {(inputs: Privacy_Policy_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Data Retention`)
};

/**
* | output |
* | --- |
* | "6. Data Retention" |
*
* @param {Privacy_Policy_Retention_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_title = /** @type {((inputs?: Privacy_Policy_Retention_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_title(inputs)
	return en_privacy_policy_retention_title(inputs)
});
export { privacy_policy_retention_title as "privacy_policy.retention.title" }